import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/logos/superseeded_logo_small@0.5x.png")